"use client"

import * as React from "react"
import { Label as LabelPrimitive } from "radix-ui"

import { cn } from "@/lib/utils"

function Label({
  className,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        "flex items-center gap-2 text-sm leading-5 font-medium text-halo-ink select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:text-halo-secondary peer-disabled:cursor-not-allowed peer-disabled:text-halo-secondary",
        className
      )}
      {...props}
    />
  )
}

export { Label }
